import React from 'react';
import { useSelector } from 'react-redux';
import { rootUrl as devUrl } from 'src/constants';
import { requestSelectors } from 'src/store/requests/selectors';
import {
  useAppPageLogo, useLanguageState,
} from 'src/hooks';
import { useLocation } from 'react-router';
import { pathList } from 'src/route-list';
import { parseUrlParts } from 'src/helpers/parseUrlParts';
import { useComplex } from 'src/hooks/app/use-complex';
import { useStyles } from './styles';

interface IAppHeaderLogo {
  isVisible?: boolean;
  customWrapperStyle?: string;
}

export const AppHeaderLogo: React.FC<IAppHeaderLogo> = React.memo(({
  isVisible = true,
  customWrapperStyle,
}) => {
  const styles = useStyles({});
  const location = useLocation();
  const rootUrl: string | null | undefined = useSelector(requestSelectors.app.getRootUrl);
  const defaultLang: any = useSelector(requestSelectors.app.getLang);
  const { currentAppLanguage } = useLanguageState();
  const { logoSrc, mainLogo } = useAppPageLogo();
  const spinnerSourceUrl = location.pathname.indexOf(pathList.home) !== -1 && logoSrc;
  const isDev = document.location.origin.indexOf(devUrl) !== -1;
  const urlFromDocument = isDev ? document.location.href : document.location.origin;
  const { complex } = useComplex();
  const rootDomainUrl = parseUrlParts(complex?.clientModuleAccessUrls?.[0]?.url)?.getDomainUrl();

  if (!isVisible) return null;

  const langSuffix = defaultLang === currentAppLanguage ? '' : currentAppLanguage;

  return (
    <div className={`${styles.headerLogo} ${customWrapperStyle || ''}`}>
      <a href={`${rootDomainUrl || rootUrl || urlFromDocument}/${langSuffix}`}>
        <img
          alt="logo"
          className={styles.appLogo}
          src={spinnerSourceUrl || mainLogo}
        />
      </a>
    </div>
  );
});
